import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import Icon from 'components/Icon';
import FlexBox from 'components/FlexBox';
import messages from '../../messages';
import Button from '../../../components/Button/Button';

export class UploadSupportingDocuments extends React.Component {
  constructor(props) {
    super(props);

    this.renderAttachment = this.renderAttachment.bind(this);
  }

  onRemove = (file) => {
    if (this.props.onDelete) {
      this.props.onDelete(file);
    }
  };

  onChange = (files) => {
    if (this.props.onChange) {
      this.props.onChange(files);
    }
  };

  onDrop = (files) => {
    this.onChange(files);
  };

  renderListAttachment() {
    const files = this.props.data;
    return (
      <div>
        {files.map((file, index) => this.renderAttachment(file, index))}
      </div>
    );
  }

  renderAttachment(file, index) {
    const { disabled, claimCode } = this.props;
    if (file.benefitCode !== claimCode) {
      return null;
    }
    return (
      <FlexBox
        justifyContent="space-between"
        style={{
          marginTop: 20,
          marginBottom: 10,
          backgroundColor: '#d1d1d1',
          padding: 10,
        }}
        key={index}
      >
        <span style={{ flex: 1, wordBreak: 'break-word' }}>{file.name}</span>
        {!disabled && (
          <Icon
            name="fa-trash-o"
            style={{ fontSize: 18, padding: 3, cursor: 'pointer' }}
            onClick={() => {
              this.onRemove(file);
            }}
          />
        )}
      </FlexBox>
    );
  }

  render() {
    const { disabled } = this.props;

    return (
      <div>
        {disabled && (
          <Dropzone
            onDrop={this.onDrop}
            style={{
              flex: 1,
              borderWidth: 1,
              borderRadius: 3,
              // borderStyle: 'dashed',
              marginTop: 5,
             // marginBottom: 20,
              paddingLeft: 15,
            }}
            multiple={false}
          >
            <div className="row align-items-center justify-content-center">
              <div className="col-auto">
                <Button disabled>
                  <FormattedMessage {...messages.upload} />
                </Button>
              </div>
            </div>
          </Dropzone>
        )}
        {!disabled && (
          <Dropzone
            onDrop={this.onDrop}
            style={{
              flex: 1,
              borderWidth: 1,
              borderRadius: 3,
              // borderStyle: 'dashed',
              marginTop: 5,
             // marginBottom: 20,
              paddingLeft: 15,
            }}
            multiple={false}
          >
            <div className="row align-items-center justify-content-center">
              <div className="col-auto">
                <Button>
                  <FormattedMessage {...messages.upload} />
                </Button>
              </div>
            </div>
          </Dropzone>
        )}
      </div>
    );
  }
}

UploadSupportingDocuments.propTypes = {
  onChange: PropTypes.func,
  data: PropTypes.array,
  onDelete: PropTypes.func,
  disabled: PropTypes.bool,
  claimCode: PropTypes.any,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/components/UploadSupportingDocuments/index.js